import { apiService } from './api';

export interface CountyOption {
  value: string;
  label: string;
  country?: string;
  region?: string;
}

export interface CountryOption {
  value: string;
  label: string;
  flag?: string;
  counties?: CountyOption[];
}

export async function fetchCountries(): Promise<CountryOption[]> {
  try {
    const data = await apiService.get<any[]>('/countries', { isPublic: true });
    console.log('Raw countries data:', data);
    
    if (!Array.isArray(data)) {
      console.error('Countries data is not an array:', data);
      return [];
    }
    
    return data.map((country: any) => {
      if (!country || typeof country !== 'object') {
        console.error('Invalid country object:', country);
        return null;
      }
      
      console.log('Processing country:', country);
      
      return {
        value: country.code || country.id || '',
        label: country.name || 'Unknown',
        flag: country.flag_url,
        counties: country.counties?.map((county: any) => ({
          value: county.code || county.id || '',
          label: county.name || 'Unknown',
          country: country.code || country.id || '',
          region: county.region || 'Other',
        })) || [],
      };
    }).filter(Boolean) as CountryOption[];
  } catch (error) {
    console.error('Error fetching countries:', error);
    return [];
  }
}

export async function fetchCounties(countryCode: string): Promise<CountyOption[]> {
  try {
    const data = await apiService.get<any[]>('/countries', { isPublic: true });
    console.log('Raw counties data for country:', countryCode, data);
    
    if (!Array.isArray(data)) {
      console.error('Counties data is not an array:', data);
      return [];
    }
    
    const country = data.find((c: any) => c.code === countryCode);
    if (!country) {
      console.error('Country not found:', countryCode);
      return [];
    }
    
    return country.counties?.map((county: any) => ({
      value: county.code || county.id || '',
      label: county.name || 'Unknown',
      country: country.code || country.id || '',
      region: county.region || 'Other',
    })) || [];
  } catch (error) {
    console.error('Error fetching counties:', error);
    return [];
  }
} 